import React from "react";
import { useSelector } from "react-redux";

function SubscriptionTag({ subscriptionType }: { subscriptionType: string | undefined }) {
  const userDetail = useSelector((state) => state?.my_account?.user_info);

  const colors: { [key: string]: string } = {
    PRO: "#164dcb",
    PRO_MONTH: "#164dcb",
    PREMIUM: "#7cdbd1",
    PREMIUM_MONTH: "#7cdbd1",
    BASIC: "#787eec",
  };
  const backgroundColor = subscriptionType ? colors[subscriptionType] : "";
  return (
    <span className="freeTrial badge text-white mb-3 " style={{ backgroundColor }}>
      {userDetail.role === "Admin" ? "ADMIN" : subscriptionType?.toLocaleUpperCase()?.split("_")[0]}
    </span>
  );
}

export default SubscriptionTag;
